class KoniPlpController {
  constructor() {
    this.bound = false;
    this.moneyFormat = window.MinimogSettings?.money_format || window.Shopify?.currency?.active || '{{amount}}';
  }

  init() {
    this.bindCards();
    this.bindFilters();
    this.bindMobileToolbar();
    if (!this.bound) {
      document.addEventListener('collection:rerendered', () => {
        this.bindCards();
        this.bindFilters();
        this.bindMobileToolbar();
        if (window.MinimogTheme?.CompareProduct) {
          MinimogTheme.CompareProduct.setCompareButtonsState();
        }
      });
      this.bound = true;
    }
  }

  bindMobileToolbar() {
    const section = document.querySelector('.koni-plp-section');
    if (!section || section.dataset.koniMobileToolbar === 'true') return;

    section.dataset.koniMobileToolbar = 'true';
    section.addEventListener('click', (event) => {
      if (event.target.closest('[data-koni-plp-open-filter]')) {
        section.querySelector('.m-sidebar--open')?.click();
      }
      if (event.target.closest('[data-koni-plp-open-sort]')) {
        section.querySelector('.m-sortby--open')?.click();
      }
    });
  }

  bindFilters() {
    const section = document.querySelector('.koni-plp-section');
    if (!section) return;

    this.initKoniFilterAccordion(section);
    this.fixFilterAccordionHeights(section);
    this.bindFilterScrollIsolation(section);
    this.bindFilterGroupScrollIsolation(section);

    section.querySelectorAll('.m-filter--widget.m-accordion--item').forEach((widget) => {
      this.setupFilterShowMore(widget);
    });

    requestAnimationFrame(() => {
      section.querySelectorAll('.m-filter--widget.m-accordion--item').forEach((widget) => {
        this.scrollActiveFilterToCenter(widget);
      });
    });
  }

  initKoniFilterAccordion(section) {
    const filtersWrapper = section.querySelector('.koni-plp-filters__wrapper');
    if (!filtersWrapper || !window.MinimogLibs?.Accordion) return;

    const collection = window.MinimogTheme?.Collection;
    if (collection?.accordions?.destroy) {
      collection.accordions.destroy();
    }

    filtersWrapper.classList.remove('acc-initialized');
    collection.accordions = new MinimogLibs.Accordion(filtersWrapper, {
      presetContentHeight: false,
      callback: () => filtersWrapper.style.setProperty('opacity', '1'),
    });

    if (filtersWrapper.dataset.koniAccordionFix !== 'true') {
      filtersWrapper.dataset.koniAccordionFix = 'true';
      filtersWrapper.addEventListener('click', (event) => {
        if (!event.target.closest('.m-accordion--item-button')) return;
        const widget = event.target.closest('.m-filter--widget.m-accordion--item');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.fixFilterAccordionHeights(section);
            this.bindFilterGroupScrollIsolation(section);
            if (widget) this.scrollActiveFilterToCenter(widget);
          });
        });
      });
    }
  }

  fixFilterAccordionHeights(section) {
    const filtersWrapper = section?.querySelector('.koni-plp-filters__wrapper');
    if (!filtersWrapper) return;

    filtersWrapper.querySelectorAll('.m-accordion--item-content').forEach((content) => {
      const item = content.closest('.m-accordion--item');
      content.classList.remove('max-height-set');
      content.style.removeProperty('max-height');
      content.style.removeProperty('overflow');
      if (item?.classList.contains('open')) {
        content.style.opacity = '1';
      }
    });

    filtersWrapper.querySelectorAll('.m-facets').forEach((list) => {
      list.style.removeProperty('--max-height');
      list.style.removeProperty('max-height');
    });

    filtersWrapper.querySelectorAll('.m-filter--scroll-content').forEach((scrollEl) => {
      scrollEl.classList.remove('m-filter--scroll-content', 'm-scrollbar--vertical');
      scrollEl.style.removeProperty('max-height');
      scrollEl.style.removeProperty('overflow');
    });
  }

  forwardWheelScroll(event, scrollEl) {
    if (!scrollEl) return false;

    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    if (maxScroll <= 0) return false;

    const nextScroll = Math.max(0, Math.min(scrollEl.scrollTop + event.deltaY, maxScroll));
    if (nextScroll === scrollEl.scrollTop) return false;

    scrollEl.scrollTop = nextScroll;
    event.preventDefault();
    return true;
  }

  bindFilterGroupScrollIsolation(section) {
    const filtersWrapper = section?.querySelector('.koni-plp-filters__wrapper');
    const sidebarScroll = section?.querySelector('.koni-plp-filters-sidebar__content');
    if (!filtersWrapper || !sidebarScroll) return;
    if (filtersWrapper.dataset.koniGroupScrollBound === 'true') return;

    filtersWrapper.dataset.koniGroupScrollBound = 'true';
    filtersWrapper.addEventListener(
      'wheel',
      (event) => {
        if (window.innerWidth < 1280) return;

        const widget = event.target.closest('.m-filter--widget.m-accordion--item.open');
        if (!widget || !filtersWrapper.contains(widget)) return;

        const groupContent = widget.querySelector('.m-accordion--item-content');
        if (!groupContent) return;

        const isExpanded = widget.classList.contains('koni-plp-filter--expanded');
        const delta = event.deltaY;

        if (!isExpanded) {
          this.forwardWheelScroll(event, sidebarScroll);
          return;
        }

        const { scrollTop, scrollHeight, clientHeight } = groupContent;
        const maxScroll = scrollHeight - clientHeight;

        if (maxScroll <= 0) {
          this.forwardWheelScroll(event, sidebarScroll);
          return;
        }

        const atTop = scrollTop <= 0;
        const atBottom = scrollTop >= maxScroll - 1;

        if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
          this.forwardWheelScroll(event, sidebarScroll);
        }
      },
      { passive: false }
    );
  }

  bindFilterScrollIsolation(section) {
    const scrollEl = section?.querySelector('.koni-plp-filters-sidebar__content');
    if (!scrollEl || scrollEl.dataset.koniScrollBound === 'true') return;
    scrollEl.dataset.koniScrollBound = 'true';

    scrollEl.addEventListener(
      'wheel',
      (event) => {
        if (window.innerWidth < 1280) return;

        const { scrollTop, scrollHeight, clientHeight } = scrollEl;
        const maxScroll = scrollHeight - clientHeight;
        if (maxScroll <= 0) return;

        const delta = event.deltaY;
        const atTop = scrollTop <= 0;
        const atBottom = scrollTop >= maxScroll - 1;

        if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
          return;
        }

        event.stopPropagation();
      },
      { passive: true }
    );
  }

  getFilterFacetItems(widget) {
    const list = widget.querySelector('.m-facets');
    if (!list) return [];
    return [...list.querySelectorAll(':scope > .m-facet--item')].filter(
      (item) => !item.classList.contains('hidden')
    );
  }

  getVisibleFacetIndices(items, checkedIndex, initialVisible, contextRadius) {
    const visibleIndices = new Set();

    if (checkedIndex >= 0) {
      const windowSize = Math.max(initialVisible, contextRadius * 2 + 1);
      let windowStart = Math.max(0, checkedIndex - contextRadius);
      let windowEnd = Math.min(items.length - 1, windowStart + windowSize - 1);
      windowStart = Math.max(0, windowEnd - windowSize + 1);

      for (let i = windowStart; i <= windowEnd; i += 1) {
        visibleIndices.add(i);
      }
      visibleIndices.add(checkedIndex);
      return visibleIndices;
    }

    for (let i = 0; i < Math.min(initialVisible, items.length); i += 1) {
      visibleIndices.add(i);
    }
    return visibleIndices;
  }

  scrollActiveFilterToCenter(widget) {
    const content = widget.querySelector('.m-accordion--item-content');
    const checkedItem = widget.querySelector('.m-facets .m-facet--item input:checked')?.closest('.m-facet--item');
    if (!content || !checkedItem || !widget.classList.contains('open')) return;

    const contentRect = content.getBoundingClientRect();
    const itemRect = checkedItem.getBoundingClientRect();
    const relativeTop = itemRect.top - contentRect.top + content.scrollTop;
    const targetScroll = relativeTop - content.clientHeight / 2 + itemRect.height / 2;
    content.scrollTop = Math.max(0, Math.min(targetScroll, content.scrollHeight - content.clientHeight));
  }

  collapseFilterFacetVisibility(widget, items, initialVisible, contextRadius) {
    widget.classList.remove('koni-plp-filter--expanded');

    items.forEach((item) => {
      item.classList.remove('koni-plp-facet--more', 'koni-plp-facet--revealed');
    });

    const checkedIndex = items.findIndex((item) => item.querySelector('input:checked'));
    const visibleIndices = this.getVisibleFacetIndices(
      items,
      checkedIndex,
      initialVisible,
      contextRadius
    );

    items.forEach((item, index) => {
      if (!visibleIndices.has(index)) {
        item.classList.add('koni-plp-facet--more');
      }
    });
  }

  expandFilterFacetVisibility(widget) {
    widget.classList.add('koni-plp-filter--expanded');

    widget.querySelectorAll('.koni-plp-facet--more').forEach((item) => {
      item.classList.remove('koni-plp-facet--more');
      item.classList.add('koni-plp-facet--revealed');
    });
  }

  setupFilterShowMore(widget) {
    const list = widget.querySelector('.m-facets');
    if (!list) return;

    const initialVisible = 5;
    const contextRadius = 3;
    const items = this.getFilterFacetItems(widget);

    widget.classList.remove('koni-plp-filter--expanded');

    items.forEach((item) => {
      item.classList.remove('koni-plp-facet--more', 'koni-plp-facet--revealed');
    });

    const checkedIndex = items.findIndex((item) => item.querySelector('input:checked'));
    const visibleIndices = this.getVisibleFacetIndices(
      items,
      checkedIndex,
      initialVisible,
      contextRadius
    );

    if (items.length <= initialVisible) {
      widget.querySelector('[data-koni-filter-show-more]')?.remove();
      this.scrollActiveFilterToCenter(widget);
      return;
    }

    items.forEach((item, index) => {
      if (!visibleIndices.has(index)) {
        item.classList.add('koni-plp-facet--more');
      }
    });

    let btn = widget.querySelector('[data-koni-filter-show-more]');
    const content = widget.querySelector('.m-accordion--item-content');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'koni-plp-filters__show-more';
      btn.dataset.koniFilterShowMore = '';
    }
    if (content) {
      content.insertAdjacentElement('afterend', btn);
    } else {
      list.insertAdjacentElement('afterend', btn);
    }

    const label =
      widget.querySelector('.m-filter--widget-title span')?.textContent?.trim() || 'options';

    const updateLabel = () => {
      if (widget.classList.contains('koni-plp-filter--expanded')) {
        btn.hidden = false;
        btn.textContent = `Show less ${label.toLowerCase()}`;
        return;
      }

      const remaining = widget.querySelectorAll('.koni-plp-facet--more').length;
      if (remaining <= 0) {
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      btn.textContent = `Show more ${label.toLowerCase()} (${remaining})`;
    };

    btn.onclick = () => {
      if (widget.classList.contains('koni-plp-filter--expanded')) {
        this.collapseFilterFacetVisibility(widget, items, initialVisible, contextRadius);
      } else {
        this.expandFilterFacetVisibility(widget);
      }

      updateLabel();
      const section = widget.closest('.koni-plp-section');
      window.MinimogTheme?.Collection?.accordions?.setContentHeight?.();
      this.fixFilterAccordionHeights(section);
      this.bindFilterGroupScrollIsolation(section);
      requestAnimationFrame(() => {
        this.scrollActiveFilterToCenter(widget);
      });
    };

    updateLabel();
    this.scrollActiveFilterToCenter(widget);
  }

  bindCards() {
    document.querySelectorAll('[data-koni-plp-card]').forEach((card) => {
      if (card.dataset.koniPlpBound === 'true') return;
      card.dataset.koniPlpBound = 'true';
      this.bindSpringTabs(card);
      this.bindSpecsToggle(card);
    });
  }

  bindSpringTabs(card) {
    const tabs = card.querySelectorAll('.koni-plp-card__spring-tab');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.switchSpring(card, tab));
    });
  }

  bindSpecsToggle(card) {
    const toggle = card.querySelector('[data-koni-plp-specs-toggle]');
    const wrap = card.querySelector('[data-koni-plp-specs-wrap]');
    if (!toggle || !wrap) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;
      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      wrap.classList.toggle('is-open', nextExpanded);

      let specs =
        wrap.querySelector('.koni-plp-card__specs-panel.is-active .koni-plp-specs') ||
        wrap.querySelector('.koni-plp-card__specs-panel:not([hidden]) .koni-plp-specs') ||
        wrap.querySelector('.koni-plp-specs');

      if (specs) {
        specs.hidden = !nextExpanded;
      }
    });
  }

  getAtcState(tab) {
    const available = tab.dataset.available === 'true';
    const inventoryPolicy = tab.dataset.inventoryPolicy;
    const inventoryQuantity = parseInt(tab.dataset.inventoryQuantity, 10) || 0;
    const hasPreorderTag = tab.dataset.hasPreorderTag === 'true';

    if (!available) return 'sold_out';
    if (inventoryPolicy === 'continue' && inventoryQuantity <= 0) {
      return hasPreorderTag ? 'preorder' : 'backorder';
    }
    return 'in_stock';
  }

  getAtcLabel(atcWrap, state) {
    if (state === 'sold_out') return atcWrap.dataset.soldOutText || 'Sold out';
    if (state === 'preorder') return atcWrap.dataset.preorderText || 'Pre-order';
    if (state === 'backorder') return atcWrap.dataset.backorderText || 'Backordered';
    return atcWrap.dataset.addText || 'Add to cart';
  }

  atcCartIcon() {
    return `<svg class="koni-plp-card__atc-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M5.33268 14.6668C5.70087 14.6668 5.99935 14.3684 5.99935 14.0002C5.99935 13.632 5.70087 13.3335 5.33268 13.3335C4.96449 13.3335 4.66602 13.632 4.66602 14.0002C4.66602 14.3684 4.96449 14.6668 5.33268 14.6668Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6667 14.6668C13.0349 14.6668 13.3333 14.3684 13.3333 14.0002C13.3333 13.632 13.0349 13.3335 12.6667 13.3335C12.2985 13.3335 12 13.632 12 14.0002C12 14.3684 12.2985 14.6668 12.6667 14.6668Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 1.3667H2.70052L4.47385 9.6467C4.53891 9.94994 4.70763 10.221 4.951 10.4133C5.19436 10.6055 5.49712 10.7069 5.80719 10.7H12.3272C12.6306 10.6995 12.9248 10.5956 13.1612 10.4053C13.3976 10.215 13.5619 9.94972 13.6272 9.65337L14.7272 4.70003H3.41385" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }

  atcButtonInner(label, state) {
    const icon = this.atcCartIcon();
    const chevron = `<svg class="koni-plp-card__atc-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    if (state === 'sold_out') {
      return `<span data-koni-plp-atc-text>${label}</span>`;
    }
    return `${icon}<span data-koni-plp-atc-text>${label}</span>${chevron}`;
  }

  switchSpring(card, tab) {
    const springKey = tab.dataset.springKey;
    if (!springKey) return;

    card.querySelectorAll('.koni-plp-card__spring-tab').forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    card.dataset.activeSpring = springKey;
    card.dataset.productId = tab.dataset.productId;

    const skuEl = card.querySelector('[data-koni-plp-sku]');
    if (skuEl) skuEl.textContent = tab.dataset.sku || '';

    const titleLink = card.querySelector('[data-koni-plp-title-link]');
    if (titleLink) {
      titleLink.textContent = tab.dataset.title || '';
      titleLink.href = tab.dataset.url || titleLink.href;
    }

    const imageLink = card.querySelector('[data-koni-plp-image-link]');
    if (imageLink) imageLink.href = tab.dataset.url || imageLink.href;

    const imageWrap = card.querySelector('[data-koni-plp-image-wrap]');
    const img = imageWrap?.querySelector('img[data-koni-plp-image]') || imageWrap?.querySelector('img');
    if (img && tab.dataset.image) {
      img.src = tab.dataset.image;
      img.alt = tab.dataset.imageAlt || '';
    }

    this.updatePrice(card, tab);
    this.updateSpecBars(card, tab, springKey);
    this.updateSpecsPanels(card, springKey);
    this.updateAtc(card, tab);
    this.updateCompare(card, tab);
    this.updateWishlist(card, tab);
    this.updateStockBadge(card, tab);
  }

  updatePrice(card, tab) {
    const priceEl = card.querySelector('[data-koni-plp-price]');
    const compareEl = card.querySelector('[data-koni-plp-compare-price]');
    const monthlyEl = card.querySelector('[data-koni-plp-monthly-price]');
    const price = parseInt(tab.dataset.price, 10) || 0;
    const comparePrice = parseInt(tab.dataset.comparePrice, 10) || 0;
    const installments = parseInt(card.dataset.financeInstallments, 10) || 3;

    if (priceEl && typeof formatMoney === 'function') {
      priceEl.textContent = formatMoney(price, this.moneyFormat);
    }

    if (monthlyEl && typeof formatMoney === 'function' && installments > 0) {
      monthlyEl.textContent = formatMoney(Math.round(price / installments), this.moneyFormat);
    }

    if (compareEl) {
      if (comparePrice > price && typeof formatMoney === 'function') {
        compareEl.textContent = formatMoney(comparePrice, this.moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  getSpringLogoUrls(card) {
    const section = card.closest('.koni-plp-section');
    return {
      apex: card.dataset.springLogoApex || section?.dataset.springLogoApex || '',
      hr: card.dataset.springLogoHr || section?.dataset.springLogoHr || '',
    };
  }

  springFeatureHtml(card, springKey) {
    const apex = 'https://cdn.shopify.com/s/files/1/1023/7001/7544/files/image_30.png?v=1783410919';
    const hr = 'https://cdn.shopify.com/s/files/1/1023/7001/7544/files/image_29.png?v=1783410917';

    if (springKey === 'apex_yellow' || springKey === 'apex_black') {
      return `<img class="koni-plp-feature__spring-logo koni-plp-feature__spring-logo--apex" src="${apex}" alt="APEX Suspension Systems" loading="lazy">`;
    }
    return `<img class="koni-plp-feature__spring-logo koni-plp-feature__spring-logo--hr" src="${hr}" alt="H&amp;R" loading="lazy">`;
  }

  setFeatureVariant(el, baseClass, variant) {
    if (!el || !variant) return;
    const prefix = `${baseClass}-`;
    [...el.classList].forEach((cls) => {
      if (cls.startsWith(prefix)) el.classList.remove(cls);
    });
    el.classList.add(`${baseClass}-${variant}`);
  }

  updateSpecBars(card, tab, springKey) {
    const axleBar = card.querySelector('[data-koni-plp-axle-bar]');
    const axleEl = card.querySelector('[data-koni-plp-axle-value]');
    const strutBar = card.querySelector('[data-koni-plp-strut-bar]');
    const strutEl = card.querySelector('[data-koni-plp-strut-value]');
    const springBar = card.querySelector('[data-koni-plp-spring-bar]');
    const springVisual = card.querySelector('[data-koni-plp-spring-visual]');

    if (axleEl && tab.dataset.axleValue) axleEl.textContent = tab.dataset.axleValue;
    if (strutEl && tab.dataset.strutValue) strutEl.textContent = tab.dataset.strutValue;

    if (axleBar && tab.dataset.axleVariant) {
      this.setFeatureVariant(axleBar, 'koni-plp-feature--axle', tab.dataset.axleVariant);
    }
    if (strutBar && tab.dataset.strutVariant) {
      this.setFeatureVariant(strutBar, 'koni-plp-feature--strut', tab.dataset.strutVariant);
      strutBar.dataset.strutVariant = tab.dataset.strutVariant;
    }

    if (springBar) {
      springBar.className = `koni-plp-feature koni-plp-feature--spring koni-plp-feature--${springKey}`;
    }
    if (springVisual) {
      springVisual.innerHTML = this.springFeatureHtml(card, springKey);
    }
  }

  updateSpecsPanels(card, springKey) {
    const wrap = card.querySelector('[data-koni-plp-specs-wrap]');
    if (!wrap) return;

    const toggle = card.querySelector('[data-koni-plp-specs-toggle]');
    const expanded = toggle?.getAttribute('aria-expanded') === 'true';

    wrap.querySelectorAll('.koni-plp-card__specs-panel').forEach((panel) => {
      const isActive = panel.dataset.springSpecs === springKey;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
      const specs = panel.querySelector('.koni-plp-specs');
      if (specs) specs.hidden = !expanded;
    });
  }

  updateStockBadge(card, tab) {
    const badge = card.querySelector('[data-koni-plp-stock-badge]');
    const atcWrap = card.querySelector('[data-koni-plp-atc]');
    if (!badge) return;

    const state = this.getAtcState(tab);
    const labelMap = {
      in_stock: atcWrap?.dataset.inStockText || 'In stock',
      sold_out: atcWrap?.dataset.soldOutText || 'Sold out',
      preorder: atcWrap?.dataset.preorderText || 'Pre-order',
      backorder: atcWrap?.dataset.backorderText || 'Backordered',
    };

    badge.className = `koni-plp-card__tag koni-plp-card__tag--stock koni-plp-card__tag--stock-${state}`;
    badge.textContent = labelMap[state] || labelMap.in_stock;
  }

  updateAtc(card, tab) {
    const atcWrap = card.querySelector('[data-koni-plp-atc]');
    if (!atcWrap) return;

    const variantId = tab.dataset.variantId;
    const productId = tab.dataset.productId;
    const available = tab.dataset.available === 'true';
    const url = tab.dataset.url || '#';
    const state = this.getAtcState(tab);
    const label = this.getAtcLabel(atcWrap, state);
    const productForm = atcWrap.querySelector('product-form');
    const currentProductId = productForm?.dataset.productId;

    if (productForm && currentProductId && currentProductId !== productId) {
      if (available) {
        atcWrap.innerHTML = `<a class="koni-plp-card__atc-btn koni-plp-card__atc-btn--${state}" href="${url}" data-koni-plp-atc-link>${this.atcButtonInner(label, state)}</a>`;
      } else {
        atcWrap.innerHTML = `<button class="koni-plp-card__atc-btn koni-plp-card__atc-btn--sold_out koni-plp-card__atc-btn--disabled" type="button" disabled>${this.atcButtonInner(label, 'sold_out')}</button>`;
      }
      return;
    }

    const variantInput = atcWrap.querySelector('[data-koni-plp-variant-input]');
    if (variantInput && productForm) {
      variantInput.value = variantId;
      productForm.dataset.productId = productId;
      const form = atcWrap.querySelector('form');
      if (form) form.dataset.productId = productId;

      const btn = atcWrap.querySelector('.koni-plp-card__atc-btn');
      if (btn) {
        btn.disabled = !available;
        btn.className = `koni-plp-card__atc-btn koni-plp-card__atc-btn--${state} m-spinner-button`;
        if (!available) btn.classList.add('koni-plp-card__atc-btn--disabled');
        const textEl = btn.querySelector('[data-koni-plp-atc-text]');
        if (textEl) textEl.textContent = label;
      }
      return;
    }

    const link = atcWrap.querySelector('[data-koni-plp-atc-link]');
    if (link) {
      link.href = url;
      link.className = `koni-plp-card__atc-btn koni-plp-card__atc-btn--${state}`;
      const textEl = link.querySelector('[data-koni-plp-atc-text]');
      if (textEl) textEl.textContent = label;
    }
  }

  updateCompare(card, tab) {
    const compareBtns = card.querySelectorAll('[data-koni-plp-compare]');
    if (!compareBtns.length) return;

    const handle = tab.dataset.productHandle;
    if (handle) {
      compareBtns.forEach((compareBtn) => {
        compareBtn.dataset.productHandle = handle;
      });
      if (window.MinimogTheme?.CompareProduct) {
        MinimogTheme.CompareProduct.setCompareButtonsState();
      }
    }
  }

  updateWishlist(card, tab) {
    const buttons = card.querySelectorAll('.m-wishlist-button');
    if (!buttons.length) return;

    const handle = tab.dataset.productHandle;
    if (!handle) return;

    const inWishlist = Array.isArray(window.MinimogTheme?.Wishlist?.products)
      && MinimogTheme.Wishlist.products.indexOf(handle) >= 0;

    buttons.forEach((btn) => {
      btn.dataset.productHandle = handle;
      const textEl = btn.querySelector('.m-wishlist-button-text');
      const addText = textEl?.dataset.addText;
      const removeText = textEl?.dataset.removeText;

      if (inWishlist) {
        btn.classList.add('added-to-wishlist');
        if (textEl && addText && removeText) {
          textEl.textContent = removeText;
          textEl.dataset.revertText = addText;
        }
      } else {
        btn.classList.remove('added-to-wishlist');
        if (textEl && addText && removeText) {
          textEl.textContent = addText;
          textEl.dataset.revertText = removeText;
        }
      }
    });
  }
}

const KoniPlp = new KoniPlpController();
window.KoniPlp = KoniPlp;
